import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import {
  getReportedRoute,
  subscribeNavigationRoute,
  type ReportedRoute,
} from '@navigation/utils/routeReporter';

/**
 * Always-mounted a11y probe so Appium/WDIO can read the active React Navigation route.
 *
 * - testID / accessibility id: `current-route`
 * - accessibilityLabel: leaf route name (e.g. DataBrowser)
 * - accessibilityHint: nested path (e.g. Dashboard/Data/DataBrowser)
 * - accessibilityValue.text: mapped .tsx path when known
 */
const CurrentRouteMarker = () => {
  const [route, setRoute] = useState<ReportedRoute>(() => getReportedRoute());

  useEffect(() => subscribeNavigationRoute(setRoute), []);

  if (!route.name) {
    return null;
  }

  return (
    <View
      testID="current-route"
      accessibilityLabel={route.name}
      accessibilityHint={route.path || undefined}
      accessibilityValue={route.file ? { text: route.file } : undefined}
      accessible
      importantForAccessibility="yes"
      pointerEvents="none"
      style={styles.marker}
    />
  );
};

const styles = StyleSheet.create({
  marker: {
    position: 'absolute',
    width: 1,
    height: 1,
    opacity: 0.01,
    left: 0,
    top: 0,
    zIndex: 0,
  },
});

export default CurrentRouteMarker;
